import { render, staticRenderFns } from "./OtpVerificationPopup.vue?vue&type=template&id=c7a7b8f8&"
import script from "./OtpVerificationPopup.vue?vue&type=script&lang=js&"
export * from "./OtpVerificationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports